export const ARTICLES_DEFAULT_LABELS = {
	title: 'Latest News'
};
